const {rz} = window;

// Animation & Transitions after scroll starts here:
export default function setObserver(container, target, fixedTop, callback1, callback2) {
  let alreadySet = false;
  // const scrn = rz.documentSize();
  // const wnds = rz.windowSize();
  setTimeout(() => {
    if (target && container) {
      window.addEventListener("scroll", () => {
        const trgrect = target.getBoundingClientRect(), cntrect = container.getBoundingClientRect();
        // Debug:
        if (!rz.isFunction(callback2)) console.log({trg: trgrect.top, cnt: (cntrect.top + cntrect.height), fixedTop, alreadySet});

        // detecting if element is fully visible
        if ((fixedTop && trgrect.top <= fixedTop) || (!fixedTop && (cntrect.top + cntrect.height) >= trgrect.top)) {
          // intersect !!!
          if (!alreadySet) {
            alreadySet = true;
            setTimeout(() => {
              if (callback1 && rz.isFunction(callback1)) callback1();
            }, 500);
          }
        }
        else if (alreadySet) {
          alreadySet = false;
          setTimeout(() => {
            if (callback2 && rz.isFunction(callback2)) callback2();
          }, 500);
        }
      });
    }
  }, 500);
}
